/**
 * Šířka obrazovky pro React.
 *
 * Prvek se má kreslit jednou, ne dvakrát schovaný přes CSS. Kde se liší
 * telefonní a počítačová podoba (akce v hlavičce, tabulka versus karty,
 * listování obdobím), rozhoduje tohle, ne dvojice `hidden sm:flex`
 * a `sm:hidden` se stejným popiskem: dvojí vykreslení znamená stejný text
 * dvakrát v dokumentu a čtečka i test pak sáhnou na ten neviditelný.
 *
 * Podmínka je schválně stejná jako zlomový bod `sm` v tailwind.config.js,
 * včetně výšky, ať se JS a CSS nikdy nerozejdou.
 *
 * Vzor: pm-app, src/lib/obrazovka.js.
 */
import { useEffect, useState } from "react";

const DOTAZ_UZKA = "(max-width: 639px), (max-height: 499px)";

/** true, když je zařízení v telefonním rozvržení (úzké nebo nízké). */
export function useUzkaObrazovka() {
  const [uzka, setUzka] = useState(() =>
    typeof window === "undefined" ? false : window.matchMedia(DOTAZ_UZKA).matches
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mq = window.matchMedia(DOTAZ_UZKA);
    const zmena = (e) => setUzka(e.matches);
    // Safari pod 14 nezná addEventListener na MediaQueryList.
    if (mq.addEventListener) mq.addEventListener("change", zmena);
    else mq.addListener(zmena);
    setUzka(mq.matches);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", zmena);
      else mq.removeListener(zmena);
    };
  }, []);

  return uzka;
}

/**
 * Zámek rolování pod otevřeným překryvem.
 *
 * `overflow: hidden` na body iOS Safari ignoruje, pod modálem se pak roluje
 * stránka vzadu a vypadá to, jako by okno přestalo reagovat. Drží až
 * `position: fixed`; posun se zapamatuje a po zavření vrátí, jinak by
 * stránka skočila nahoru.
 *
 * Stejná technika je v layout/SpodniLista.jsx u sheetu Více.
 */
export function useZamekRolovani(aktivni) {
  useEffect(() => {
    if (!aktivni || typeof document === "undefined") return undefined;
    const y = window.scrollY;
    const b = document.body;
    const puvodni = { overflow: b.style.overflow, position: b.style.position, top: b.style.top, width: b.style.width };
    b.style.overflow = "hidden";
    b.style.position = "fixed";
    b.style.top = `-${y}px`;
    b.style.width = "100%";
    return () => {
      Object.assign(b.style, puvodni);
      window.scrollTo(0, y);
    };
  }, [aktivni]);
}
